import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || supabaseUrl.includes('tvoj_url')) {
  console.error("GRESKA: Nisi unio ispravne Supabase ključeve u .env fajl!");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);